//#region src/domain/i18n/country-flag.ts
var CountryFlag = /* @__PURE__ */ function(CountryFlag) {
	CountryFlag["DO"] = "🇩🇴";
	CountryFlag["GT"] = "🇬🇹";
	CountryFlag["HN"] = "🇭🇳";
	CountryFlag["PE"] = "🇵🇪";
	return CountryFlag;
}({});
//#endregion
export { CountryFlag };

//# sourceMappingURL=country-flag.js.map